import { Bank } from '../bank';
import { Departement } from '../departement';

export class Employee {

    id: number|undefined;
    active: boolean;
    matricule:string;
    poste:string;
    firstname:string;
    lastname:string;
    initiale:string;
    businessEmail:string;
    businessPhone:string;
    mobilePhone:string;
    username:string;
    password:string;
    passwordUpdateAt:string;
    photo:string;
    photoContentType:string;
    signature:string;
    signatureContentType:string;
    backupUsername:string;
    departement:Departement;
    bank:Bank;
    codeAgent : string;
  }
  